import { render } from "./aio-login-tabs.vue?vue&type=template&id=99ffc11e&scoped=true"
import script from "./aio-login-tabs.vue?vue&type=script&lang=js"
export * from "./aio-login-tabs.vue?vue&type=script&lang=js"

import "./aio-login-tabs.vue?vue&type=style&index=0&id=99ffc11e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99ffc11e"]])

export default __exports__